// extracted by mini-css-extract-plugin
export var accentColor = "#ff723d";
export var categoryBorderColor = "#f08300";
export var disableRipple = "false";
export var fontFamily = "\"Roboto\",\"Helvetica\",\"Arial\",sans-serif";
export var mainColor = "#f08300";
export var mainContrast = "rgba(0,0,0,.87)";
export var panelBorderColor = "#f08300";
export var secondaryColor = "#0b3190";
export var secondaryContrast = "#fff";